var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "btn-group dropleft", attrs: { role: "group" } },
    [
      _c(
        "button",
        {
          staticClass: "btn dropdown-toggle-split p-0",
          attrs: {
            type: "button",
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false"
          }
        },
        [
          _c("span", { staticClass: "sr-only" }),
          _vm._v(" "),
          _vm.selectedTabName !== "Archived"
            ? _c("img", {
                staticStyle: { width: "5px" },
                attrs: {
                  src:
                    "https://szue2patcraftblobpstb01.blob.core.windows.net/media/patcraft/media/patcraftmedia/frontendicons/ellipsis-vertical-solid.svg",
                  alt: ""
                }
              })
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dropdown-menu bg-white",
          attrs: { "aria-labelledby": "dropdownMenuLink" }
        },
        [
          _vm.showHideEdit
            ? _c(
                "a",
                {
                  ref: "dynamicEditLink",
                  staticClass: "dropdown-item font-16",
                  attrs: { href: "/VirtualTray/EditTray/" + _vm.card.id }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$resourceString["account.Trays.Option.Edit"]) +
                      "\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedTabName === "Archived" || _vm.selectedTabName === "Active"
            ? _c(
                "a",
                {
                  staticClass: "dropdown-item font-16",
                  class: { disabled: _vm.isDisabled },
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.handleArchiveTray($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.selectedTabName === "Archived"
                          ? _vm.$resourceString[
                              "account.MyTray.Button.Reactivate"
                            ]
                          : _vm.$resourceString["account.Trays.Option.Archive"]
                      )
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showHideEdit &&
          _vm.card.sections.some(function(section) {
            return (
              section.title === "default" && section.contentItems.length != 0
            )
          })
            ? _c(
                "a",
                {
                  staticClass: "dropdown-item font-16",
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.shareTray(_vm.card.id)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$resourceString["account.Trays.Option.Share"]
                      ) +
                      "\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedTabName === "Brand" &&
          (_vm.card.brandBoardStatus === 0 ||
            _vm.card.brandBoardStatus === 1) &&
          _vm.isAdminMode
            ? _c(
                "a",
                {
                  staticClass: "dropdown-item font-16",
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.publishTray(_vm.card.id)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$resourceString["account.Trays.Option.Publish.Tray"]
                      ) +
                      "\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedTabName === "Brand" &&
          (_vm.card.brandBoardStatus === 2 ||
            _vm.card.brandBoardStatus === 1) &&
          _vm.isAdminMode
            ? _c(
                "a",
                {
                  staticClass: "dropdown-item font-16",
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.unpublishTray(_vm.card.id)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$resourceString[
                          "account.Trays.Option.Unpublish.Tray"
                        ]
                      ) +
                      "\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown-divider" }),
          _vm._v(" "),
          _vm.isAdminMode ||
          _vm.selectedTabName === "Archived" ||
          _vm.selectedTabName === "Active"
            ? _c(
                "a",
                {
                  staticClass: "dropdown-item font-danger font-16",
                  class: { disabled: _vm.isDisabled },
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.handleDeleteTray($event)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$resourceString["account.Trays.Option.Delete"]
                      ) +
                      "\n    "
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }